export default function MapToolTip(
  state = { show: false, tipHtml: null },
  action
) {
  switch (action.type) {
    case 'SET_MAP_TOOLTIP': {
      return action.payload
    }
    default:
      return state
  }
}
